export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-axis/src/identity.js
// module id = ../../../../d3-axis/src/identity.js
// module chunks = vendor